import { render, staticRenderFns } from "./SvgImg.vue?vue&type=template&id=51a54e44"
import script from "./SvgImg.vue?vue&type=script&lang=js"
export * from "./SvgImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports